import React, { useState, useEffect, useRef } from 'react';
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';

const COUNTRIES = [
  { code: 'BR', name: 'Brasil', dial: '+55', mask: '(##) #####-####' },
  { code: 'US', name: 'Estados Unidos', dial: '+1', mask: '(###) ###-####' },
  { code: 'PT', name: 'Portugal', dial: '+351', mask: '### ### ###' },
  { code: 'AO', name: 'Angola', dial: '+244', mask: '### ### ###' },
  { code: 'MZ', name: 'Moçambique', dial: '+258', mask: '## ### ####' },
  { code: 'CV', name: 'Cabo Verde', dial: '+238', mask: '### ## ##' },
  { code: 'AR', name: 'Argentina', dial: '+54', mask: '(###) ###-####' },
  { code: 'ES', name: 'Espanha', dial: '+34', mask: '### ### ###' },
  { code: 'FR', name: 'França', dial: '+33', mask: '## ## ## ## ##' },
  { code: 'GB', name: 'Reino Unido', dial: '+44', mask: '#### ######' },
  { code: 'DE', name: 'Alemanha', dial: '+49', mask: '#### ########' },
  { code: 'IT', name: 'Itália', dial: '+39', mask: '### #######' },
  { code: 'MX', name: 'México', dial: '+52', mask: '(##) ####-####' },
  { code: 'CL', name: 'Chile', dial: '+56', mask: '# #### ####' },
  { code: 'CO', name: 'Colômbia', dial: '+57', mask: '### ### ####' },
  { code: 'PE', name: 'Peru', dial: '+51', mask: '### ### ###' },
  { code: 'CA', name: 'Canadá', dial: '+1', mask: '(###) ###-####' },
  { code: 'AU', name: 'Austrália', dial: '+61', mask: '#### ### ###' },
  { code: 'NZ', name: 'Nova Zelândia', dial: '+64', mask: '## ### ####' },
  { code: 'IN', name: 'Índia', dial: '+91', mask: '#####-#####' },
  { code: 'JP', name: 'Japão', dial: '+81', mask: '## #### ####' },
  { code: 'CN', name: 'China', dial: '+86', mask: '### #### ####' },
  { code: 'RU', name: 'Rússia', dial: '+7', mask: '(###) ###-##-##' },
  { code: 'ZA', name: 'África do Sul', dial: '+27', mask: '## ### ####' },
  { code: 'NG', name: 'Nigéria', dial: '+234', mask: '### ### ####' },
  { code: 'TR', name: 'Turquia', dial: '+90', mask: '(###) ### ## ##' },
  { code: 'SA', name: 'Arábia Saudita', dial: '+966', mask: '## ### ####' },
  { code: 'AE', name: 'Emirados Árabes', dial: '+971', mask: '## ### ####' },
  { code: 'IL', name: 'Israel', dial: '+972', mask: '##-#######' },
  { code: 'KR', name: 'Coreia do Sul', dial: '+82', mask: '##-####-####' },
  { code: 'ID', name: 'Indonésia', dial: '+62', mask: '###-####-####' },
  { code: 'TH', name: 'Tailândia', dial: '+66', mask: '## #### ####' },
  { code: 'VN', name: 'Vietnã', dial: '+84', mask: '## #### ####' },
  { code: 'PH', name: 'Filipinas', dial: '+63', mask: '### ### ####' },
  { code: 'MY', name: 'Malásia', dial: '+60', mask: '##-### ####' },
  { code: 'SG', name: 'Cingapura', dial: '+65', mask: '#### ####' },
  { code: 'HK', name: 'Hong Kong', dial: '+852', mask: '#### ####' },
  { code: 'TW', name: 'Taiwan', dial: '+886', mask: '### ### ###' },
  { code: 'EG', name: 'Egito', dial: '+20', mask: '## #### ####' },
  { code: 'MA', name: 'Marrocos', dial: '+212', mask: '##-####-####' },
  { code: 'KE', name: 'Quênia', dial: '+254', mask: '### ######' },
  { code: 'CH', name: 'Suíça', dial: '+41', mask: '## ### ## ##' },
  { code: 'SE', name: 'Suécia', dial: '+46', mask: '## ### ## ##' },
  { code: 'NO', name: 'Noruega', dial: '+47', mask: '### ## ###' },
  { code: 'DK', name: 'Dinamarca', dial: '+45', mask: '## ## ## ##' },
  { code: 'FI', name: 'Finlândia', dial: '+358', mask: '## ### ## ##' },
  { code: 'BE', name: 'Bélgica', dial: '+32', mask: '### ## ## ##' },
  { code: 'NL', name: 'Holanda', dial: '+31', mask: '## ########' },
  { code: 'PL', name: 'Polônia', dial: '+48', mask: '### ### ###' },
  { code: 'UA', name: 'Ucrânia', dial: '+380', mask: '## ### ####' },
  { code: 'GR', name: 'Grécia', dial: '+30', mask: '### #######' },
  { code: 'CZ', name: 'República Checa', dial: '+420', mask: '### ### ###' },
  { code: 'RO', name: 'Romênia', dial: '+40', mask: '## ### ####' },
  { code: 'HU', name: 'Hungria', dial: '+36', mask: '## ### ####' },
  { code: 'AT', name: 'Áustria', dial: '+43', mask: '#### #######' },
  { code: 'IE', name: 'Irlanda', dial: '+353', mask: '## #######' },
];



function formatPhone(value, mask) {
  if (!value) return "";
  let v = String(value).replace(/\D/g, '');
  if (v.length === 0) return "";

  let result = "";
  let vIndex = 0;
  for (let mIndex = 0; mIndex < mask.length; mIndex++) {
    if (mask[mIndex] === '#') {
      if (vIndex < v.length) {
        result += v[vIndex];
        vIndex++;
      } else break;
    } else {
      if (vIndex < v.length) {
        result += mask[mIndex];
      }
    }
  }
  return result;
}

function parseMessageToHtml(msg) {
  if (!msg) return '<span style="color:#9CA3AF;font-style:italic;font-size:12px">Sua mensagem aparecerá aqui...</span>';
  return msg
    .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
    .replace(/\n/g, '<br/>')
    .replace(/\*(.*?)\*/g, '<b>$1</b>')
    .replace(/_(.*?)_/g, '<i>$1</i>')
    .replace(/~(.*?)~/g, '<strike>$1</strike>');
}

export default function App() {
  const [selectedCountry, setSelectedCountry] = useState(COUNTRIES[0]);
  const [phoneRaw, setPhoneRaw] = useState('');
  const [message, setMessage] = useState('Olá! Gostaria de mais informações sobre seus serviços.');
  const [generatedLink, setGeneratedLink] = useState('');
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [copyFeedback, setCopyFeedback] = useState(false);
  const [countrySearch, setCountrySearch] = useState('');
  const [showQrModal, setShowQrModal] = useState(false);
  const [downloadingQr, setDownloadingQr] = useState(false);
  const [isEditorFocused, setIsEditorFocused] = useState(false);

  const countryWrapRef = useRef(null);
  const emojiPickerRef = useRef(null);
  const emojiBtnRef = useRef(null);
  const messageInputRef = useRef(null);

  // Click outside and Escape key handler
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showCountryDropdown && countryWrapRef.current && !countryWrapRef.current.contains(event.target)) {
        setShowCountryDropdown(false);
      }
      if (showEmojiPicker && emojiPickerRef.current && !emojiPickerRef.current.contains(event.target) && (!emojiBtnRef.current || !emojiBtnRef.current.contains(event.target))) {
        setShowEmojiPicker(false);
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setShowQrModal(false);
        setShowCountryDropdown(false);
        setShowEmojiPicker(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [showCountryDropdown, showEmojiPicker]);

  const handlePhoneInput = (e) => {
    const raw = e.target.value.replace(/\D/g, '');
    const maskMaxChars = (selectedCountry.mask.match(/#/g) || []).length;
    if (raw.length <= maskMaxChars) {
      setPhoneRaw(raw);
      setGeneratedLink(''); // Reseta o link gerado se o usuário alterar o telefone
    }
  };

  const handleCountrySelect = (c) => {
    setSelectedCountry(c);
    setPhoneRaw('');
    setShowCountryDropdown(false);
    setCountrySearch('');
    setGeneratedLink('');
  };

  const insertAtCursor = (textToInsert, wrap = false) => {
    const input = messageInputRef.current;
    if (!input) return;

    const start = input.selectionStart;
    const end = input.selectionEnd;
    const text = message;
    const selectedText = text.substring(start, end);

    let newText = '';
    let newStart = start;
    let newEnd = end;

    if (wrap && selectedText) {
      // Envolver texto selecionado com o caractere de formatação
      newText = text.substring(0, start) + textToInsert + selectedText + textToInsert + text.substring(end);
      newStart = start + textToInsert.length;
      newEnd = start + textToInsert.length + selectedText.length;
    } else if (wrap && !selectedText) {
      // Se não há seleção, inserir caractere duplo para o usuário digitar no meio
      newText = text.substring(0, start) + textToInsert + textToInsert + text.substring(end);
      newStart = start + textToInsert.length;
      newEnd = start + textToInsert.length;
    } else {
      // Para emojis, apenas inserir
      newText = text.substring(0, start) + textToInsert + text.substring(end);
      newStart = start + textToInsert.length;
      newEnd = start + textToInsert.length;
    }

    setMessage(newText);

    setTimeout(() => {
      input.focus();
      input.setSelectionRange(newStart, newEnd);
    }, 0);
  };

  const generateLink = () => {
    if (!phoneRaw) return;
    const dial = selectedCountry.dial.replace('+', '');
    const fullNumber = `${dial}${phoneRaw}`;
    const encodedMessage = encodeURIComponent(message);
    setGeneratedLink(`https://wa.me/${fullNumber}?text=${encodedMessage}`);
  };

  const copyToClipboard = async () => {
    if (!generatedLink) return;
    try {
      await navigator.clipboard.writeText(generatedLink);
    } catch {
      const tmp = document.createElement('textarea');
      tmp.value = generatedLink;
      document.body.appendChild(tmp);
      tmp.select();
      document.execCommand('copy');
      document.body.removeChild(tmp);
    }
    setCopyFeedback(true);
    setTimeout(() => setCopyFeedback(false), 2000);
  };

  const downloadQrCode = async () => {
    if (!generatedLink || downloadingQr) return;
    setDownloadingQr(true);
    try {
      const imageUrl = `https://api.qrserver.com/v1/create-qr-code/?size=500x500&data=${encodeURIComponent(generatedLink)}&bgcolor=FFFFFF&format=png`;
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `linkzap-qrcode-${selectedCountry.code}.png`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Erro ao baixar QR Code:', err);
    } finally {
      setDownloadingQr(false);
    }
  };

  const isGenerateEnabled = phoneRaw.length > 0;
  const filteredCountries = COUNTRIES.filter(c =>
    c.name.toLowerCase().includes(countrySearch.toLowerCase()) || c.dial.includes(countrySearch)
  );

  const waTitle = phoneRaw ? formatPhone(phoneRaw, selectedCountry.mask) : selectedCountry.name;
  const currentTime = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

  return (
    <>
      <style>{`
        :root {
          --bg: #1A1F23;
          --bg2: #15191C;
          --panel: #23292F;
          --panel2: #2A3036;
          --border: #374151;
          --muted: #9CA3AF;
          --text: #E5E7EB;
          --accent: #FFC600;
          --zap: #25D366;
        }
        * { box-sizing: border-box; }
        body {
          margin: 0;
          /* ensure color emoji fonts are available for flags and emojis */
          font-family: 'Sora', system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif, 'Segoe UI Emoji', 'Apple Color Emoji', 'Noto Color Emoji', 'Segoe UI Symbol';
          background: var(--bg);
          color: var(--text);
          padding-bottom: 80px;
        }
        .flag {
          font-family: 'Segoe UI Emoji', 'Apple Color Emoji', 'Noto Color Emoji', 'Segoe UI Symbol', sans-serif;
        }
        ::selection { background: var(--accent); color: #000; }
        .custom-scroll::-webkit-scrollbar { width: 6px; }
        .custom-scroll::-webkit-scrollbar-track { background: var(--panel2); }
        .custom-scroll::-webkit-scrollbar-thumb { background: #4B5563; border-radius: 3px; }
        
        main { padding: 32px 0 48px; }
        .container { max-width: 1140px; margin: 0 auto; padding: 0 16px; }
        .grid { display: grid; grid-template-columns: 1fr; gap: 28px; }
        @media (min-width: 1024px) {
          main { padding: 48px 0 60px; }
          .grid { grid-template-columns: 7fr 5fr; gap: 48px; }
        }

        .title h2 { margin: 0; font-size: 34px; font-weight: 800; letter-spacing: -.6px; color: #fff; }
        .title p { margin: 8px 0 0; font-size: 18px; color: var(--muted); }

        .block { margin-top: 18px; }
        .label { display: flex; align-items: center; gap: 8px; font-size: 13px; font-weight: 700; color: #D1D5DB; margin-bottom: 10px; }
        .row { display: flex; gap: 12px; flex-direction: column; }
        @media (min-width: 640px) { .row { flex-direction: row; } }

        .btn { border: 1px solid var(--border); background: var(--panel); color: #fff; border-radius: 14px; height: 56px; padding: 0 16px; display: flex; align-items: center; justify-content: space-between; cursor: pointer; transition: .15s; outline: none; }
        .btn:hover { border-color: var(--accent); }
        .btn:focus { box-shadow: 0 0 0 3px rgba(255, 198, 0, .25); }
        .dial { display: flex; align-items: center; gap: 12px; font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; font-weight: 700; font-size: 18px; }
        .flag { font-size: 22px; line-height: 1; }

        .dropdown-wrap { position: relative; min-width: 160px; }
        .dropdown { position: absolute; top: 64px; left: 0; width: 320px; background: var(--panel2); border: 1px solid var(--border); border-radius: 14px; overflow: hidden; box-shadow: 0 24px 60px rgba(0, 0, 0, .55); z-index: 30; display: none; }
        .dropdown.open { display: block; }
        .dropdown-top { padding: 10px; background: var(--panel); border-bottom: 1px solid var(--border); }
        .searchbox { position: relative; }
        .searchbox input { width: 100%; background: var(--bg); color: #fff; border: 0; border-radius: 10px; padding: 10px 12px 10px 34px; outline: none; font-size: 13px; box-shadow: inset 0 0 0 1px rgba(255, 255, 255, .04); }
        .searchbox input:focus { box-shadow: inset 0 0 0 1px rgba(255, 198, 0, .7); }
        .searchbox .icon { position: absolute; left: 10px; top: 10px; width: 14px; height: 14px; opacity: .6; }
        .dropdown-list { max-height: 260px; overflow: auto; }
        .country-item { width: 100%; padding: 12px 14px; display: flex; align-items: center; gap: 12px; border: 0; background: transparent; cursor: pointer; text-align: left; color: #fff; border-bottom: 1px solid rgba(55, 65, 81, .35); transition: .12s; }
        .country-item:hover { background: #323940; }
        .country-item:last-child { border-bottom: 0; }
        .country-item .name { font-size: 13px; font-weight: 700; }
        .country-item .dialmini { margin-left: auto; font-size: 11px; font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; color: var(--muted); background: rgba(0, 0, 0, .2); padding: 4px 6px; border-radius: 8px; border: 1px solid rgba(255, 255, 255, .06); }

        .phone-input { flex: 1; height: 56px; background: var(--panel); border: 1px solid var(--border); border-radius: 14px !important; padding: 0 16px 0 18px; color: #fff; outline: none; font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; font-size: 20px; letter-spacing: .6px; box-shadow: inset 0 2px 10px rgba(0, 0, 0, .25); transition: .15s; width: 100%; }
        .phone-input::placeholder { color: #6B7280; }
        .phone-input:focus { border-color: var(--accent); box-shadow: inset 0 2px 10px rgba(0, 0, 0, .25), 0 0 0 1px rgba(255, 198, 0, .7); }

        .msg-head { display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 10px; }
        .chars { font-size: 10px; letter-spacing: .12em; text-transform: uppercase; color: #6B7280; font-weight: 800; background: var(--panel); padding: 4px 8px; border-radius: 10px; }
        .editor { background: var(--panel); border: 1px solid var(--border); border-radius: 14px; box-shadow: inset 0 2px 14px rgba(0, 0, 0, .28); transition: .15s; position: relative; }
        .editor.focused { border-color: rgba(255, 198, 0, .8); box-shadow: inset 0 2px 14px rgba(0, 0, 0, .28), 0 0 0 1px rgba(255, 198, 0, .55); }
        .toolbar { display: flex; align-items: center; gap: 6px; padding: 10px; border-bottom: 1px solid rgba(55, 65, 81, .7); background: rgba(42, 48, 54, .5); border-top-left-radius: 14px; border-top-right-radius: 14px; }
        .tool { border: 0; background: transparent; color: #9CA3AF; cursor: pointer; padding: 8px; border-radius: 10px; position: relative; transition: .12s; }
        .tool:hover { background: #374151; color: #fff; }
        .divider { width: 1px; height: 18px; background: #374151; margin: 0 8px; }

        .emoji-btn { border: 0; cursor: pointer; display: flex; align-items: center; gap: 8px; font-size: 13px; font-weight: 700; padding: 7px 12px; border-radius: 10px; transition: .12s; background: transparent; color: #9CA3AF; }
        .emoji-btn:hover { background: #374151; color: #fff; }
        .emoji-btn.active { background: var(--accent); color: var(--bg); }

        .emoji-picker-wrapper { position: absolute; top: 56px; left: 10px; width: auto; max-width: calc(100vw - 48px); background: transparent; border: none; border-radius: 14px; overflow: visible; box-shadow: none; z-index: 100; }
        
        em-emoji-picker {
          --rgb-background: 42, 48, 54 !important;
          --rgb-accent: 255, 198, 0 !important;
          --rgb-input-background: 26, 31, 35 !important;
          --rgb-input-border: 55, 65, 81 !important;
          --rgb-border: 55, 65, 81 !important;
          border-radius: 14px !important;
        }

        textarea { width: 100%; height: 160px; border: 0; outline: none; resize: none; background: transparent; padding: 16px; color: #fff; font-size: 15px; line-height: 1.5; border-bottom-left-radius: 14px; border-bottom-right-radius: 14px; }
        textarea::placeholder { color: #6B7280; }

        .primary { width: 100%; margin-top: 18px; height: auto; padding: 16px; border-radius: 14px; border: 0; font-weight: 900; font-size: 18px; color: var(--bg); background: var(--accent); cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 10px; transition: .15s; transform: translateY(0); }
        .primary:hover { background: #ffcf33; transform: translateY(-2px); box-shadow: 0 18px 40px rgba(255, 198, 0, .16); }
        .primary:active { transform: translateY(0); }
        .primary:disabled { background: #374151; color: #6B7280; cursor: not-allowed; opacity: .55; box-shadow: none; transform: none; }

        .result { margin-top: 18px; background: var(--panel); border: 1px solid rgba(255, 198, 0, .28); border-radius: 14px; padding: 18px; position: relative; overflow: hidden; }
        .result::before { content: ""; position: absolute; left: 0; top: 0; bottom: 0; width: 4px; background: var(--accent); }
        .result-head { display: flex; align-items: center; gap: 10px; color: var(--accent); }
        .chip { width: 32px; height: 32px; border-radius: 999px; background: rgba(255, 198, 0, .1); border: 1px solid rgba(255, 198, 0, .2); display: flex; align-items: center; justify-content: center; }
        .result-head h3 { margin: 0; font-size: 18px; font-weight: 900; color: #fff; }

        .linkbox { position: relative; margin-top: 16px; }
        .linkbox input { width: 100%; background: var(--bg); border: 1px solid var(--border); color: #D1D5DB; border-radius: 12px; padding: 16px 110px 16px 16px; font-size: 13px; font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; outline: none; }
        .linkbox input:focus { box-shadow: 0 0 0 2px rgba(255, 198, 0, .25); border-color: rgba(255, 198, 0, .65); }
        .copybtn { position: absolute; right: 10px; top: 10px; bottom: 10px; border-radius: 10px; border: 1px solid rgba(255, 255, 255, .08); background: var(--panel2); color: #D1D5DB; font-weight: 900; font-size: 12px; padding: 0 14px; cursor: pointer; display: flex; align-items: center; gap: 8px; transition: .12s; }
        .copybtn:hover { background: #FFC600; color: #1A1F23; border-color: transparent; }

        .actions { display: flex; gap: 12px; margin-top: 16px; flex-direction: column; }
        @media (min-width: 640px) { .actions { flex-direction: row; } }

        .test { flex: 1; display: flex; align-items: center; justify-content: center; gap: 8px; background: var(--zap); color: #fff; text-decoration: none; font-weight: 900; padding: 12px 14px; border-radius: 12px; transition: .12s; box-shadow: 0 16px 36px rgba(16, 185, 129, .12); }
        .test:hover { filter: brightness(.95); transform: translateY(-1px); color: #fff; }

        .qr-mini { flex: 1; background: #fff; color: #111827; border-radius: 12px; padding: 10px; display: flex; align-items: center; gap: 12px; cursor: pointer; position: relative; overflow: hidden; transition: .12s; box-shadow: 0 16px 36px rgba(0, 0, 0, .22); }
        .qr-mini:hover { background: #F9FAFB; }
        .qr-mini .maxi { position: absolute; right: 10px; top: 10px; opacity: .35; transition: .12s; }
        .qr-mini:hover .maxi { opacity: .75; }
        .qr-mini img { width: 48px; height: 48px; mix-blend-mode: multiply; }
        .qr-mini .txt1 { font-size: 11px; font-weight: 900; letter-spacing: .12em; text-transform: uppercase; margin: 0; }
        .qr-mini .txt2 { font-size: 10px; color: #6B7280; margin: 4px 0 0; }

        .preview-wrap { display: none; }
        @media (min-width: 768px) { .preview-wrap { display: block; } }
        .sticky { position: sticky; top: 96px; padding-top: 24px; }
        .preview-top { display: flex; align-items: center; justify-content: center; margin: 0 0 14px; }
        .preview-top h3 { margin: 0; font-size: 11px; font-weight: 900; color: #6B7280; letter-spacing: .12em; text-transform: uppercase; display: flex; align-items: center; gap: 8px; }
        .dot { width: 8px; height: 8px; border-radius: 999px; background: #22C55E; box-shadow: 0 0 0 6px rgba(34, 197, 94, .12); animation: pulse 1.2s infinite; }
        @keyframes pulse { 0%, 100% { transform: scale(1) } 50% { transform: scale(1.15) } }

        .phone { width: 320px; height: 620px; margin: 0 auto; background: #1f2937; border: 12px solid #1f2937; border-radius: 48px; box-shadow: 0 30px 80px rgba(0, 0, 0, .6); position: relative; overflow: hidden; outline: 1px solid rgba(255, 255, 255, .06); }
        .screen { width: 100%; height: 100%; border-radius: 36px; overflow: hidden; background: #E5DDD5; display: flex; flex-direction: column; position: relative; }
        .wa-top { height: 80px; background: #075E54; color: #fff; display: flex; align-items: center; padding: 22px 14px 0; gap: 10px; box-shadow: 0 8px 18px rgba(0, 0, 0, .25); flex: 0 0 auto; }
        .avatar { width: 36px; height: 36px; border-radius: 999px; background: #D1D5DB; border: 1px solid rgba(255, 255, 255, .15); background-size: cover; background-position: center; display: flex; align-items: center; justify-content: center; color: #075E54; font-weight: 900; font-size: 11px; overflow: hidden; }
        .wa-name { display: flex; flex-direction: column; min-width: 0; }
        .wa-name .n { font-weight: 800; font-size: 13px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 150px; line-height: 1.1; }
        .wa-name .s { font-size: 10px; opacity: .8; margin-top: 2px; }
        .wa-icons { margin-left: auto; display: flex; gap: 10px; opacity: .85; }

        .chat { flex: 1; padding: 12px; overflow: auto; background-image: url('https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png'); background-size: 400px; background-color: #E5DDD5; background-repeat: repeat; }
        .day { display: flex; justify-content: center; margin: 6px 0 14px; }
        .day span { background: #E1F3FB; color: #1f2937; font-size: 10px; font-weight: 800; text-transform: uppercase; padding: 4px 8px; border-radius: 10px; box-shadow: 0 2px 6px rgba(0, 0, 0, .12); letter-spacing: .08em; }
        .bubble-row { display: flex; justify-content: flex-end; }
        .bubble { background: #DCF8C6; color: #000; border-radius: 10px; border-top-right-radius: 0; padding: 10px 12px; max-width: 88%; box-shadow: 0 3px 10px rgba(0, 0, 0, .12); font-size: 13.5px; line-height: 1.35; word-break: break-word; }
        .time { display: flex; justify-content: flex-end; align-items: flex-end; gap: 6px; margin-top: 6px; opacity: .6; user-select: none; }
        .time span { font-size: 10px; color: #4B5563; font-weight: 700; }
        .ticks { display: flex; gap: 0; }
        .ticks svg { width: 14px; height: 14px; color: #4FC3F7; margin-left: -3px; }

        .wa-bottom { background: #F0F0F0; padding: 10px 10px 18px; display: flex; align-items: center; gap: 10px; flex: 0 0 auto; }
        .plus { font-size: 22px; color: #007AFF; line-height: 1; padding-bottom: 2px; }
        .fakeinput { flex: 1; height: 32px; background: #fff; border-radius: 999px; border: 1px solid #E5E7EB; box-shadow: 0 2px 6px rgba(0, 0, 0, .07); }
        .mic-btn { width: 32px; height: 32px; border-radius: 999px; background: #007AFF; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 6px rgba(0, 0, 0, .12); color: #fff; }

        .side-power { position: absolute; top: 112px; right: -12px; width: 3px; height: 48px; border-radius: 0 8px 8px 0; background: #374151; opacity: .8; }
        .side-vol { position: absolute; top: 112px; left: -12px; width: 3px; height: 80px; border-radius: 8px 0 0 8px; background: #374151; opacity: .8; }
        .preview-foot { margin-top: 26px; text-align: center; font-size: 10px; letter-spacing: .16em; text-transform: uppercase; color: #6B7280; opacity: .5; font-weight: 900; }

        .modal-backdrop { position: fixed; inset: 0; background: rgba(0, 0, 0, .8); backdrop-filter: blur(6px); display: none; align-items: center; justify-content: center; padding: 16px; z-index: 60; animation: fade .15s ease-out; }
        @keyframes fade { from { opacity: 0 } to { opacity: 1 } }
        .modal-backdrop.open { display: flex; }
        .modal { width: 100%; max-width: 420px; background: #fff; border-radius: 18px; overflow: hidden; box-shadow: 0 30px 90px rgba(0, 0, 0, .6); animation: pop .18s ease-out; position: relative; }
        .modal-header { display: flex; align-items: center; justify-content: space-between; padding: 14px 14px; border-bottom: 1px solid #F3F4F6; background: #F9FAFB; }
        .modal-title { display: flex; align-items: center; gap: 10px; font-weight: 900; color: #111827; font-size: 18px; margin: 0; }
        .modal-title .pill { width: 30px; height: 30px; border-radius: 10px; background: var(--bg); display: flex; align-items: center; justify-content: center; }
        .modal-close { border: 0; background: #F3F4F6; cursor: pointer; width: 44px; height: 44px; border-radius: 999px; display: flex; align-items: center; justify-content: center; color: #111827; transition: .12s; }
        .modal-close:hover { background: #E5E7EB; color: #000; }
        .modal-close svg { width: 28px; height: 28px; stroke-width: 3; }

        .modal-body { padding: 26px 22px; display: flex; flex-direction: column; align-items: center; gap: 18px; }
        .qr-big { padding: 14px; border: 4px solid var(--bg); border-radius: 14px; box-shadow: 0 16px 40px rgba(0, 0, 0, .18); position: relative; }
        .qr-big img { width: 256px; height: 256px; mix-blend-mode: multiply; }
        .qr-badge { position: absolute; right: -12px; bottom: -12px; background: var(--accent); color: var(--bg); border-radius: 999px; width: 44px; height: 44px; display: flex; align-items: center; justify-content: center; box-shadow: 0 10px 24px rgba(0, 0, 0, .22); }
        .modal-text { text-align: center; }
        .modal-text .a { margin: 0; font-weight: 900; color: #111827; font-size: 18px; }
        .modal-text .b { margin: 6px 0 0; color: #6B7280; font-size: 13px; }

        .modal-actions { width: 100%; display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-top: 6px; }
        .m-btn { height: 46px; border-radius: 14px; border: 1px solid #E5E7EB; background: #fff; cursor: pointer; font-weight: 900; color: #374151; display: flex; align-items: center; justify-content: center; gap: 8px; transition: .12s; }
        .m-btn:hover { background: #FFC600; border-color: #D1D5DB; color: #1A1F23; }
        .m-btn.dark { background: var(--bg); color: #fff; border-color: transparent; box-shadow: 0 16px 36px rgba(0, 0, 0, .18); }
        .m-btn.dark:hover { background: var(--panel2); }

        .spinner { width: 18px; height: 18px; border: 2px solid rgba(255, 255, 255, .25); border-top-color: #fff; border-radius: 999px; animation: spin 1s linear infinite; }
        @keyframes spin { to { transform: rotate(360deg) } }

        .modal-footer { padding: 10px 12px; background: #F9FAFB; border-top: 1px solid #F3F4F6; text-align: center; color: #9CA3AF; font-size: 12px; }

        .i { width: 16px; height: 16px; display: inline-block; vertical-align: -3px; }
        .i14 { width: 14px; height: 14px; }
        .i18 { width: 18px; height: 18px; }
        .i20 { width: 20px; height: 20px; }
        .i24 { width: 24px; height: 24px; }
      `}</style>

      <main>
        <div className="container">
          <div className="grid">
            <section>
              <div className="title">
                <h2>Crie seu link</h2>
                <p>Personalize sua mensagem e facilite o contato com seus clientes.</p>
              </div>

              <div className="block">
                <div className="label">
                  <svg className="i14" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.08 4.18 2 2 0 0 1 4.05 2h3a2 2 0 0 1 2 1.72c.12.86.3 1.7.54 2.5a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.58-1.05a2 2 0 0 1 2.11-.45c.8.24 1.64.42 2.5.54A2 2 0 0 1 22 16.92z"></path>
                  </svg>
                  Número de telefone
                </div>

                <div className="row">
                  <div className="dropdown-wrap" ref={countryWrapRef}>
                    <button className="btn" type="button" aria-haspopup="listbox" aria-expanded={showCountryDropdown} onClick={() => setShowCountryDropdown(!showCountryDropdown)}>
                      <span className="dial">
                        <span className="flag"><img src={`https://flagcdn.com/24x18/${selectedCountry.code.toLowerCase()}.png`} alt={selectedCountry.name} style={{width:'22px', height:'16px', objectFit:'cover'}} /></span>
                        <span>{selectedCountry.dial}</span>
                      </span>
                      <svg className="i" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="m6 9 6 6 6-6"></path>
                      </svg>
                    </button>

                    <div className={`dropdown ${showCountryDropdown ? 'open' : ''}`} role="listbox" aria-label="Lista de países">
                      <div className="dropdown-top">
                        <div className="searchbox">
                          <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <circle cx="11" cy="11" r="8"></circle>
                            <path d="m21 21-4.3-4.3"></path>
                          </svg>
                          <input type="text" placeholder="Buscar país..." autoComplete="off" value={countrySearch} onChange={(e) => setCountrySearch(e.target.value)} />
                        </div>
                      </div>
                      <div className="dropdown-list custom-scroll">
                        {filteredCountries.map((c) => (
                          <button key={c.code} type="button" className="country-item" onClick={() => handleCountrySelect(c)}>
                            <span style={{ fontSize: '22px', width:'22px', height:'16px', display:'inline-block' }}>
                              <img src={`https://flagcdn.com/24x18/${c.code.toLowerCase()}.png`} alt={c.name} style={{width:'100%', height:'100%', objectFit:'cover'}} />
                            </span>
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div className="name">{c.name}</div>
                            </div>
                            <span className="dialmini">{c.dial}</span>
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>

                  <input
                    className="phone-input"
                    type="tel"
                    placeholder={selectedCountry.mask}
                    value={formatPhone(phoneRaw, selectedCountry.mask)}
                    onChange={handlePhoneInput}
                  />
                </div>
              </div>

              <div className="block" style={{ position: 'relative' }}>
                <div className="msg-head">
                  <div className="label" style={{ margin: 0 }}>
                    <svg className="i14" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z"></path>
                    </svg>
                    Mensagem Personalizada
                  </div>
                  <span className="chars">{message.length} caracteres</span>
                </div>

                <div className={`editor ${isEditorFocused ? 'focused' : ''}`}>
                  <div className="toolbar">
                    <button className="tool" type="button" title="Negrito" onClick={() => insertAtCursor('*', true)}>
                      <svg className="i" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M6 4h8a4 4 0 0 1 0 8H6z"></path>
                        <path d="M6 12h9a4 4 0 0 1 0 8H6z"></path>
                      </svg>
                    </button>
                    <button className="tool" type="button" title="Itálico" onClick={() => insertAtCursor('_', true)}>
                      <svg className="i" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M19 4h-9"></path>
                        <path d="M14 20H5"></path>
                        <path d="M15 4 9 20"></path>
                      </svg>
                    </button>
                    <button className="tool" type="button" title="Riscado" onClick={() => insertAtCursor('~', true)}>
                      <svg className="i" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M16 4H9"></path>
                        <path d="M4 12h16"></path>
                        <path d="M14 20H8"></path>
                        <path d="M10 4a3 3 0 0 0 0 6"></path>
                        <path d="M14 14a3 3 0 0 1 0 6"></path>
                      </svg>
                    </button>

                    <div className="divider"></div>

                    <div style={{ position: 'relative' }}>
                      <button className={`emoji-btn ${showEmojiPicker ? 'active' : ''}`} type="button" ref={emojiBtnRef} onClick={() => setShowEmojiPicker(!showEmojiPicker)}>
                        <svg className="i" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <circle cx="12" cy="12" r="10"></circle>
                          <path d="M8 14s1.5 2 4 2 4-2 4-2"></path>
                          <path d="M9 9h.01"></path>
                          <path d="M15 9h.01"></path>
                        </svg>
                        <span>Emojis</span>
                      </button>

                      {showEmojiPicker && (
                        <div className="emoji-picker-wrapper" ref={emojiPickerRef} aria-label="Seletor de Emojis">
                          <Picker
                            data={data}
                            onEmojiSelect={(emoji) => {
                              insertAtCursor(emoji.native, false);
                            }}
                            locale="pt"
                            theme="dark"
                            previewPosition="none"
                            searchPosition="sticky"
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  <textarea
                    ref={messageInputRef}
                    className="custom-scroll"
                    placeholder="Escreva sua mensagem aqui..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    onFocus={() => setIsEditorFocused(true)}
                    onBlur={() => setIsEditorFocused(false)}
                  ></textarea>
                </div>
              </div>

              <button className="primary" type="button" disabled={!isGenerateEnabled} onClick={generateLink}>
                {isGenerateEnabled ? (
                  <>
                    <svg className="i24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <path d="M13 2 3 14h9l-1 8 10-12h-9z"></path>
                    </svg>
                    <span>Gerar Link Mágico</span>
                  </>
                ) : (
                  <>
                    <svg className="i24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <rect x="7" y="2" width="10" height="20" rx="2" ry="2"></rect>
                      <path d="M11 18h2"></path>
                    </svg>
                    <span>Digite o telefone para começar</span>
                  </>
                )}
              </button>

              {generatedLink && (
                <div style={{ display: 'block' }}>
                  <div className="result">
                    <div className="result-head">
                      <div className="chip">
                        <svg className="i" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M20 6 9 17l-5-5"></path>
                        </svg>
                      </div>
                      <h3>Link gerado com sucesso!</h3>
                    </div>

                    <div className="linkbox">
                      <input readOnly value={generatedLink} />
                      <button className="copybtn" type="button" onClick={copyToClipboard}>
                        <span>
                          {copyFeedback ? (
                            <svg className="i14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
                          ) : (
                            <svg className="i14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                              <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                            </svg>
                          )}
                        </span>
                        <span>{copyFeedback ? 'Copiado!' : 'Copiar'}</span>
                      </button>
                    </div>

                    <div className="actions">
                      <a className="test" href={generatedLink} target="_blank" rel="noreferrer">
                        <svg className="i20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z"></path>
                        </svg>
                        Testar Link
                      </a>

                      <div className="qr-mini" title="Clique para ampliar" onClick={() => setShowQrModal(true)}>
                        <svg className="i maxi" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ position: 'absolute', right: '10px', top: '10px', opacity: .35 }}>
                          <path d="M8 3H5a2 2 0 0 0-2 2v3"></path>
                          <path d="M16 3h3a2 2 0 0 1 2 2v3"></path>
                          <path d="M8 21H5a2 2 0 0 1-2-2v-3"></path>
                          <path d="M16 21h3a2 2 0 0 0 2-2v-3"></path>
                        </svg>
                        <div style={{ background: '#fff', padding: '6px', borderRadius: '10px', border: '1px solid #F3F4F6' }}>
                          <img src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(generatedLink)}&bgcolor=FFFFFF`} alt="QR Code" />
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <p className="txt1">QR Code</p>
                          <p className="txt2">Clique para ampliar e baixar</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </section>

            <aside className="preview-wrap">
              <div className="sticky">
                <div className="preview-top">
                  <h3><span className="dot"></span> Preview ao vivo</h3>
                </div>

                <div className="phone" aria-hidden="true">
                  <div className="screen">
                    <div className="wa-top">
                      <svg className="i20" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.9)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ transform: 'rotate(180deg)', opacity: .85 }}>
                        <path d="M5 12h14"></path>
                        <path d="m12 5 7 7-7 7"></path>
                      </svg>

                      <div className="avatar" style={{ backgroundImage: `url('https://ui-avatars.com/api/?name=${encodeURIComponent(selectedCountry.code)}&background=random')` }}></div>

                      <div className="wa-name">
                        <div className="n">{waTitle}</div>
                        <div className="s">visto por último hoje às 10:45</div>
                      </div>

                      <div className="wa-icons">
                        <svg className="i18" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.9)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.08 4.18 2 2 0 0 1 4.05 2h3a2 2 0 0 1 2 1.72c.12.86.3 1.7.54 2.5a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.58-1.05a2 2 0 0 1 2.11-.45c.8.24 1.64.42 2.5.54A2 2 0 0 1 22 16.92z"></path>
                        </svg>
                        <svg className="i18" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.9)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <circle cx="12" cy="12" r="10"></circle>
                          <path d="M2 12h20"></path>
                          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                        </svg>
                      </div>
                    </div>

                    <div className="chat custom-scroll">
                      <div className="day"><span>Hoje</span></div>
                      <div className="bubble-row">
                        <div className="bubble">
                          <div dangerouslySetInnerHTML={{ __html: parseMessageToHtml(message) }}></div>
                          <div className="time">
                            <span>{currentTime}</span>
                            <span className="ticks" aria-hidden="true">
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="wa-bottom">
                      <div className="plus">+</div>
                      <div className="fakeinput"></div>
                      <div className="mic-btn">
                        <svg viewBox="0 0 24 24" fill="currentColor" style={{ width: '18px', height: '18px' }}>
                          <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z"></path>
                          <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"></path>
                        </svg>
                      </div>
                    </div>
                  </div>

                  <div className="side-power"></div>
                  <div className="side-vol"></div>
                </div>

                <div className="preview-foot">LinkZap Preview System</div>
              </div>
            </aside>
          </div>
        </div>
      </main>

      {/* QR Code Modal */}
      <div className={`modal-backdrop ${showQrModal ? 'open' : ''}`} role="dialog" aria-modal="true" aria-label="QR Code" onClick={(e) => { if (e.target.classList.contains('modal-backdrop')) setShowQrModal(false); }}>
        <div className="modal" role="document">
          <div className="modal-header">
            <h3 className="modal-title">
              <span className="pill" aria-hidden="true">
                <svg className="i18" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="18" cy="5" r="3"></circle>
                  <circle cx="6" cy="12" r="3"></circle>
                  <circle cx="18" cy="19" r="3"></circle>
                  <path d="M8.59 13.51 15.42 17.49"></path>
                  <path d="M15.41 6.51 8.59 10.49"></path>
                </svg>
              </span>
              Seu QR Code
            </h3>
            <button className="modal-close" type="button" aria-label="Fechar" onClick={() => setShowQrModal(false)}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 6 6 18"></path>
                <path d="M6 6l12 12"></path>
              </svg>
            </button>
          </div>

          <div className="modal-body">
            <div className="qr-big">
              {generatedLink && (
                <img src={`https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(generatedLink)}&bgcolor=FFFFFF`} alt="QR Code Grande" />
              )}
              <div className="qr-badge" aria-hidden="true">
                <svg className="i20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M13 2 3 14h9l-1 8 10-12h-9z"></path>
                </svg>
              </div>
            </div>

            <div className="modal-text">
              <p className="a">Pronto para compartilhar!</p>
              <p className="b">Escaneie com a câmera do celular ou baixe a imagem.</p>
            </div>

            <div className="modal-actions">
              <button className="m-btn" type="button" onClick={copyToClipboard}>
                <span>
                  {copyFeedback ? (
                    <svg className="i18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
                  ) : (
                    <svg className="i18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                    </svg>
                  )}
                </span>
                <span>{copyFeedback ? 'Link Copiado' : 'Copiar Link'}</span>
              </button>

              <button className="m-btn dark" type="button" onClick={downloadQrCode}>
                <span>
                  {downloadingQr ? (
                    <span className="spinner" aria-hidden="true" style={{ display: 'inline-block' }}></span>
                  ) : (
                    <svg className="i18" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                      <path d="M7 10l5 5 5-5"></path>
                      <path d="M12 15V3"></path>
                    </svg>
                  )}
                </span>
                <span>Baixar PNG</span>
              </button>
            </div>
          </div>

          <div className="modal-footer">Gerado via LinkZap • Alta Resolução</div>
        </div>
      </div>
    </>
  );
}